export const SET_COOKIE_BANNER_HEIGHT = 'SET_COOKIE_BANNER_HEIGHT';

export const SET_HEADER_HEIGHT = 'SET_HEADER_HEIGHT';
